module.exports = __webpack_public_path__ + "img/dark_ic_new_upload.690ee76a.png";